var chunkToChildrenMap = {
	"227": [
		4484,
		3139
	],
	"4484": [
		3054,
		8038
	],
	"4793": [
		3139
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };